<template>
  <div class="insurance-codan clearfix">
    <img
      class="insurance-codan__logo"
      alt="Codan logo"
      src="/static/img/raster/codan-logo.png"
    />
    <div class="insurance-codan__container">
      <div class="insurance-codan__inline-start">
        <h2 class="insurance-codan__header">
          Få et tilbud på<br />
          en <b>ordentlig</b> <br />
          bilforsikring her
        </h2>
      </div>
      <div class="insurance-codan__inline-end">
        <ul class="insurance-codan__list">
          <li class="insurance-codan__list-item">
            Bliv elitebillist fra dag 1
          </li>
          <li class="insurance-codan__list-item">
            Ingen selvrisiko på flere alm. skader
          </li>
          <li class="insurance-codan__list-item">
            Parkeringsskader - 0 kr. i selvrisiko
          </li>
        </ul>
      </div>
    </div>
    <button @click="trigger" class="insurance-codan__button button">
      Beregn din pris
    </button>
    <img
      v-if="showPixel"
      src="https://track.adform.net/adfserve/?bn=60295738;1x1inv=1;srctype=3;ord=[timestamp];"
      border="0"
      width="1"
      height="1"
    />
  </div>
</template>

<script>
import { app } from '@/main'

import {
  LogWidgetRedirectInsuranceCodan,
  LogWidgetShownInsuranceCodan,
} from '@/events'

export default {
  name: 'InsuranceCodan',
  data() {
    return {
      showPixel: false,
    }
  },
  methods: {
    trigger() {
      window.open('https://track.adform.net/C/?bn=60295738')

      LogWidgetRedirectInsuranceCodan()
    },
  },
  mounted() {
    LogWidgetShownInsuranceCodan()

    app.mitt.emit('insurance-module-loaded')

    // if cookie accepted
    if (window.CookieInformation.getConsentGivenFor('cookie_cat_marketing')) {
      this.showPixel = true
    }
  },
}
</script>

<style lang="scss">
@import 'InsuranceCodan.scss';
</style>
